import backendServices from '@department-of-veterans-affairs/platform-user/profile/backendServices';

export const serviceRequired = [
  backendServices.FORM526,
  backendServices.ORIGINAL_CLAIMS,
];

export const idRequired = [
  // checks if EDIPI & SSN exists
  backendServices.EVSS_CLAIMS,
  // checks if EDIPI, SSN & either a BIRLS ID or Participant ID exists
  backendServices.ORIGINAL_CLAIMS,
];

// Note: redux's `user.profile.services` comes from the API's
// `data.attributes.services` (top-level), not `data.attributes.profile.services`
// (which doesn't exist). The platform's mapRawUserDataToState flattens
// API attributes into the profile reducer slice.
export const hasRequiredServices = profile =>
  serviceRequired.some(service => profile.services.includes(service));

export const hasRequiredId = profile =>
  idRequired.some(service => profile.services.includes(service));

export const hasRequiredDob = profile => !!profile.dob;
